import { render, staticRenderFns } from "./KaufManiKunden.vue?vue&type=template&id=b4e8431c&scoped=true&"
import script from "./KaufManiKunden.vue?vue&type=script&lang=js&"
export * from "./KaufManiKunden.vue?vue&type=script&lang=js&"
import style0 from "./KaufManiKunden.vue?vue&type=style&index=0&id=b4e8431c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e8431c",
  null
  
)

export default component.exports